import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';

// Kept out of any .vue template as a helper — a literal `{{...}}` inside a Vue
// mustache interpolation trips up Vue's own template compiler, and baked
// directly into an i18n message string it trips up vue-i18n's message
// compiler ("Not allowed nest placeholder") too. Always call this from script
// and pass the result in as a named i18n interpolation param when it needs to
// appear inside a translated sentence.
export const asPlaceholder = variable => `{{${variable}}}`;

const CONTACT_FIELD_KEYS = [
  'name',
  'first_name',
  'last_name',
  'email',
  'phone_number',
];

// Authoritative variable list shared by every WhatsApp variable picker in the
// app — mirrors exactly what resolves a recipient's message at send time:
// ContactDrop (app/drops/contact_drop.rb), used by both the unofficial
// SendToContactJob#render_body and the official
// Whatsapp::LiquidTemplateProcessorService.
export function useContactVariableGroups() {
  const { t } = useI18n();
  const contactCustomAttributes = useMapGetter(
    'attributes/getContactAttributes'
  );

  const variableGroups = computed(() => {
    const groups = [
      {
        key: 'contact',
        label: t(
          'METRICA_WHATSAPP_CAMPAIGNS.TEMPLATES.VARIABLES_PANEL.CONTACT_GROUP'
        ),
        variables: CONTACT_FIELD_KEYS.map(field => ({
          key: `contact.${field}`,
          // eslint-disable-next-line @intlify/vue-i18n/no-dynamic-keys
          label: t(
            `METRICA_WHATSAPP_CAMPAIGNS.TEMPLATES.VARIABLES_PANEL.FIELDS.${field.toUpperCase()}`
          ),
        })),
      },
    ];

    const customAttributes = contactCustomAttributes.value || [];
    if (customAttributes.length) {
      groups.push({
        key: 'custom',
        label: t(
          'METRICA_WHATSAPP_CAMPAIGNS.TEMPLATES.VARIABLES_PANEL.CUSTOM_GROUP'
        ),
        variables: customAttributes.map(attribute => ({
          key: `contact.custom_attribute.${attribute.attributeKey}`,
          label: attribute.attributeDisplayName,
        })),
      });
    }

    return groups;
  });

  return { variableGroups };
}
